import { IValidate } from "../../interfaces/IValidate";
import { IValidationProperties } from "../../interfaces/IValidationProperties";
import { BaseValidator } from "./BaseValidator";
export class TextValidator extends BaseValidator implements IValidate {
  constructor(validationProperties: IValidationProperties) {
    super(validationProperties)
  }
}